<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div v-if="loading" class="loading">
      <clip-loader />
    </div>
    <div class="row mt-4" v-else>
      <div class="col-12">
        Fitlre :
        <span v-bind:class="confirmedClass" v-on:click="clickConfirmed">confirmé</span>
        <span v-bind:class="unconfirmedClass" v-on:click="clickUnconfirmed">non confirmé</span>
      </div>
      <div class="col-12">
        <table class="table table-stripped table-sm mt-2">
          <thead>
            <tr>
              <th>#</th>
              <th>Username</th>
              <th>Email</th>
              <th>Date d'inscription</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users" v-bind:key="user.Username">
              <td>{{index + 1}}</td>
              <td>{{user.Username}}</td>
              <td>{{user.Attributes.find(a => a.Name === 'email').Value}}</td>
              <td>{{toDate(user.UserCreateDate)}}</td>
              <td v-if="user.UserStatus === 'CONFIRMED'">Confirmé</td>
              <td v-else>Non confirmé</td>
              <td v-if="user.UserStatus === 'UNCONFIRMED'">
                <button class="btn btn-primary btn-sm"
                  v-on:click="confirmUser(user.Username)">
                  Confirmer</button>
              </td>
              <td v-else></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12" v-if="nextToken">
        <button class="btn btn-link" v-on:click="clickNext">+ Plus de résultats</button>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import LoggedUser from '../LoggedUser.vue';
import BottomNav from '../BottomNav.vue';
import ClipLoader from '../ClipLoader.vue';

const padZero = n => ((n < 10) ? `0${n}` : n);

export default {
  name: 'AdminCognito',
  components: { LoggedUser, BottomNav, ClipLoader },
  data() {
    return {
      users: [],
      loading: true,
      paginationToken: undefined,
      nextToken: undefined,
      filterUserStatus: undefined,
    };
  },
  computed: {
    confirmedClass() {
      return {
        badge: true,
        'text-bg-light': !this.filterUserStatus || this.filterUserStatus === 'UNCONFIRMED',
        'text-bg-info': this.filterUserStatus === 'CONFIRMED',
      };
    },
    unconfirmedClass() {
      return {
        badge: true,
        'text-bg-light': !this.filterUserStatus || this.filterUserStatus === 'CONFIRMED',
        'text-bg-info': this.filterUserStatus === 'UNCONFIRMED',
      };
    },
  },
  created() {
    this.getUsers().then((users) => {
      this.users = users.Users;
      this.nextToken = users.PaginationToken;
      this.loading = false;
    });
  },
  methods: {
    getUsers() {
      const params = new URLSearchParams();
      if (this.filterUserStatus) {
        params.append('filter', `cognito:user_status="${this.filterUserStatus}"`);
      }
      if (this.paginationToken) {
        params.append('paginationToken', this.paginationToken);
      }
      return this.$http.get(`${import.meta.env.VITE_LCT_API_URL}/cognito-users?${params.toString()}`)
        .then(response => response.data);
    },
    toDate(timestamp) {
      const d = new Date(timestamp);
      return `${padZero(d.getDate())}/${padZero(d.getMonth() + 1)}/${d.getFullYear()} ${padZero(d.getHours())}:${padZero(d.getMinutes())}`;
    },
    clickConfirmed() {
      this.paginationToken = undefined;
      this.filterUserStatus = this.filterUserStatus === 'CONFIRMED' ? undefined : 'CONFIRMED';
      this.getUsers().then((users) => {
        this.users = users.Users;
        this.nextToken = users.PaginationToken;
      });
    },
    clickUnconfirmed() {
      this.paginationToken = undefined;
      this.filterUserStatus = this.filterUserStatus === 'UNCONFIRMED' ? undefined : 'UNCONFIRMED';
      this.getUsers().then((users) => {
        this.users = users.Users;
        this.nextToken = users.PaginationToken;
      });
    },
    clickNext() {
      this.paginationToken = this.nextToken;
      this.getUsers().then((users) => {
        this.users = [].concat(this.users, users.Users);
        this.nextToken = users.PaginationToken;
        this.loading = false;
      });
    },
    confirmUser(username) {
      this.$http.put(`${import.meta.env.VITE_LCT_API_URL}/cognito-users/${username}`, {
        confirmed: true,
      })
        .then(() => this.getUsers())
        .then((users) => {
          this.users = users.Users;
          this.nextToken = users.PaginationToken;
        });
    },
  },
};
</script>

<style scoped>
.loading {
  height: 200px;
  margin-top: 30px;
}
.userid{
  font-size: 0.6rem;
}
.badge {
  cursor: pointer;
}
</style>
